import { Link } from "react-router-dom";
import { allCategories } from "@/utils/community";

export default function CategoryQuickLinks() {
  return (
    <section className="w-full px-4 md:px-8 py-12 md:py-16">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-3 mb-8">
        <div>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">快捷分类入口</h2>
          <p className="mt-2 text-sm md:text-base text-foreground-600">
            从感兴趣的话题开始，找到属于你的圈子
          </p>
        </div>
        <Link
          to="/category/interests"
          className="text-sm font-medium text-primary-700 hover:text-primary-800 inline-flex items-center gap-1 whitespace-nowrap cursor-pointer"
        >
          浏览全部分类
          <i className="ri-arrow-right-line" />
        </Link>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-5">
        {allCategories.map((cat) => (
          <Link
            key={cat.id}
            to={`/category/${cat.id}`}
            className="group p-4 md:p-5 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-300 hover:bg-background-50 transition-all cursor-pointer"
          >
            <span className="w-12 h-12 md:w-14 md:h-14 rounded-lg bg-primary-100 text-primary-700 flex items-center justify-center group-hover:bg-primary-500 group-hover:text-foreground-950 transition-colors">
              <i className={`${cat.icon} text-2xl md:text-3xl`} />
            </span>
            <h3 className="mt-4 text-base md:text-lg font-semibold text-foreground-950 group-hover:text-primary-700 transition-colors">
              {cat.name}
            </h3>
            <p className="mt-1.5 text-xs md:text-sm text-foreground-600 line-clamp-2 leading-relaxed">
              {cat.description}
            </p>
            <p className="mt-3 text-xs text-foreground-400">{cat.topicCount} 个话题</p>
          </Link>
        ))}
      </div>
    </section>
  );
}